/**
 * BgKineticLines — Parallel horizontal lines with wave motion
 * Registro: urgência/energia/hook — pain points, interrupção atenção, momentos críticos
 * Paleta: vermelho/pain por padrão, configurável
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig} from "remotion";

interface BgKineticLinesProps {
  lineColor?: string;
  count?: number;
  amplitude?: number;
  speed?: number;
  opacity?: number;
}

export const BgKineticLines: React.FC<BgKineticLinesProps> = ({
  lineColor = "#EF4444",
  count = 14,
  amplitude = 12,
  speed = 1,
  opacity = 0.12,
}) => {
  const f = useCurrentFrame();
  const {fps, width, height} = useVideoConfig();
  const t = (f / fps) * speed;

  const lines = Array.from({length: count}, (_, i) => {
    const baseY = (i / (count - 1)) * height;
    const phaseOffset = i * (Math.PI * 2 / count) * 0.7;
    const waveY = Math.sin(t * 1.2 + phaseOffset) * amplitude;
    const lineOpacity = opacity * (0.5 + Math.abs(Math.sin(t * 0.8 + i * 0.3)) * 0.5);
    const distFromCenter = Math.abs(i / count - 0.5) * 2;
    const thickness = 2 - distFromCenter * 0.8;
    return {baseY, waveY, opacity: lineOpacity, thickness};
  });

  return (
    <AbsoluteFill style={{background: "#080808", overflow: "hidden"}}>
      {/* Pain tint blob */}
      <div style={{
        position: "absolute",
        left: "50%", top: "40%",
        width: "70%", height: "60%",
        transform: "translate(-50%,-50%)",
        background: `radial-gradient(ellipse, ${lineColor}18 0%, transparent 70%)`,
        filter: "blur(80px)",
      }}/>
      {/* Kinetic lines — coordinates in px via useVideoConfig */}
      <svg style={{position: "absolute", inset: 0, width: "100%", height: "100%"}}
           viewBox={`0 0 ${width} ${height}`}>
        {lines.map((line, i) => {
          const y = line.baseY + line.waveY;
          const midY = y + Math.sin(t * 1.5 + i * 0.5) * amplitude * 0.3;
          const isAccent = i % 3 === 0;
          return (
            <path key={i}
              d={`M -10 ${y} Q ${width / 2} ${midY} ${width + 10} ${y}`}
              stroke={isAccent ? lineColor : `${lineColor}99`}
              strokeWidth={line.thickness}
              strokeOpacity={isAccent ? line.opacity * 1.6 : line.opacity}
              fill="none"
            />
          );
        })}
      </svg>
      {/* Energy flash */}
      {f % 62 < 4 && (
        <div style={{
          position: "absolute", inset: 0,
          background: `linear-gradient(180deg, transparent 0%, ${lineColor}0a 50%, transparent 100%)`,
          pointerEvents: "none",
        }}/>
      )}
      {/* Vignette */}
      <div style={{
        position: "absolute", inset: 0,
        background: "radial-gradient(ellipse at 50% 50%, transparent 35%, rgba(0,0,0,0.75) 100%)",
        pointerEvents: "none",
      }}/>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
